<template>
  <div class="column">
    <div class="card" style="margin-top:2px; min-height: 862px;">
      <div class="card-header">
        <div class="pec-header" style="margin: 0 auto;">
          <performanceitem id="headkpi"
                           :overallByWave="getOverallByWave"
                           :isBMWMoto="true" />
        </div>
      </div>
      <div class="card-body col-15">
        <div class="il-table">
          <div class="il-row col-15">
            <!-- Cluster 1 Welcome and Reception -->
            <div class="il-cell col-3">
              <tableitem :overallByWave="getOverallByWave"
                         :hideNSC="true"
                         :isHeader="true"
                         :isBMWMoto="true" />
              <!-- <titleunderline /> -->
              <div class="dash-card-inner">
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiAutoresponse"
                           :isBMWMoto="true" />
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiFirstpersonalcontact"
                           :isBMWMoto="true" />
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getReferencetoenquiry"
                           :isBMWMoto="true" />
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiNextSteps"
                           :isBMWMoto="true" />
                <tableitem :overallByWave="getOverallByWave"
                           :kpi="getKpiSettinganappointment"
                           :isBMWMoto="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import performanceitem from './PerformanceItem'
  import tableitem from './TableItem.vue'
  import WideNscItem from './WideNscItem.vue'
  //import titleunderline from './TitleUnderline'

  export default {
    name: 'BMWMotorradOnLineProcessExcellenceColumn',
    data: function () {
      return {
        kpi1: {}
      }
    },

    components: {
      performanceitem,
      tableitem,
      WideNscItem
      //,titleunderline
    },

    props: [
      'dashdata',
    ],

    methods: {
      getKpiByString: function (code) {
        if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0) {
          const kpi = _.find(this.dashdata.KPI, (x) => x.KpiCode === code);
          // console.log('Looking for: ' + code);
          // console.log(kpi);
          return kpi;
        }
      },
      getKpiGroupByString: function (code) {
        if (this.dashdata && this.dashdata.KPIGroup && _.size(this.dashdata.KPIGroup) > 0)
          return _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === code)
      },
      getQuestionByString: function (code) {
        if (this.dashdata && this.dashdata.Question && _.size(this.dashdata.Question) > 0)
          return _.find(this.dashdata.Question, (x) => x.KpiCode === code)
      },
    },

    computed: {

      getOverallByWave: function () {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return this.dashdata.OverallByWave[0]
        return undefined
      },


      // Welcome Contact Column
      getKpiAutoresponse: function () {
        return this.getKpiByString('03. Auto response');
      },
      getKpiFirstpersonalcontact: function () {
        return this.getKpiByString('05. First personal contact (up to 5 working days)');
      },
      getReferencetoenquiry: function () {
        return this.getKpiByString('11. Reference to enquiry');
      },
      getKpiNextSteps: function () {
        return this.getKpiByString('12. Next steps');
      },
      getKpiSettinganappointment: function () {
        return this.getKpiByString('13. Setting an appointment');
      }
    }
  }

</script>
<style scoped>


  .rectindicator {
    display: inline-block;
    margin-left: 6px;
    width: 16px;
    height: 16px;
    vertical-align: top;
    margin-top: 12.5px;
  }

  .headertext {
    display: inline-block;
    height: 24pt;
    text-align: center;
    color: #111111;
    position: relative;
    top: -6px;
    display: inline-block;
    font-weight: 500;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

  .headertextspace {
    width: 10px;
  }

  #headtext2 {
    height: 24pt;
    text-align: center;
    color: #111111;
    position: relative;
    top: -6px;
    display: inline-block;
    font-weight: 500;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

  .column {
    margin: 0px;
    padding: 0px;
    position: relative;
    top: 0px;
    margin-block-end: 0px;
    margin-inline-end: 0px;
  }

  .subitem {
    margin-inline-start: 6px;
    margin-inline-end: 6px;
    margin-block-start: 2px;
    margin-block-end: 2px;
  }

  .subitemlostleadsstyle {
    margin-inline-start: 36px;
    margin-inline-end: 6px;
    margin-block-start: 2px;
    margin-block-end: 2px;
  }

  .col-3 {
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
    border-width: 0px;
  }

  .card-header:first-child {
    border-radius: 0px;
    margin: 0px;
    padding: 0px;
  }

  .card-header {
    background: #d9d9d9;
    border-width: 0px;
    width: 100%;
    height: 40px;
  }

  .pec-header {
    display: table;
    margin: 0 auto;
  }

  .card-body {
    padding: 0px;
    margin: 0px;
  }

  .card {
    border: solid #bfbfbf;
    border-width: 2px;
    border-radius: 0rem;
    margin: 0px;
    padding: 0px;
    padding-left: 44px;
    height: 700px;
    vertical-align: top;
  }

  .il-table {
    font-size: 9pt;
    font-size-adjust: inherit;
    height: fit-content;
    width: 100%;
    display: table;
  }

  .il-row {
    width: 100%;
    float: left;
  }

  #dimmedout {
    opacity: 0.5;
    filter: alpha(opacity=50);
  }

  .il-cell {
    float: left;
    width: 20%;
    text-overflow: ellipsis;
    display: table-cell;
  }

  .pec-card {
    float: left;
  }

  .dash-card-inner {
    weight: 30%;
  }

  .card {
    margin-top: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    padding: 0px;
  }

  h3 {
    height: 36pt;
    line-height: 28pt;
    text-align: center;
    float: left;
    top: 0px;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }
</style>
